<h1 mat-dialog-title>Duplicate Tasks Warning</h1>
<button mat-dialog-close mat-icon-button test-id="close-dialog">
  <mat-icon>close</mat-icon>
</button>

<div class="fill" mat-dialog-content>
  <p class="description dialog-padding">
    The tasks listed below already exist in the system. These tasks have not yet been duplicated. Please note that
    non-duplicate tasks will still be created regardless of which action is taken here.
  </p>
  <div class="table-wrapper">
    <table mat-table multiTemplateDataRows [dataSource]="duplicates">
      <ng-container matColumnDef="select">
        <th *matHeaderCellDef mat-header-cell>
          <mat-checkbox
            test-id="duplicate-select-all"
            [checked]="selectedTaskCount > 0 && duplicates.data.length === selectedTaskCount"
            [indeterminate]="selectedTaskCount > 0 && duplicates.data.length !== selectedTaskCount"
            (change)="toggleSelectAll($event.checked)"
          />
        </th>
        <td *matCellDef="let element" mat-cell>
          <mat-checkbox
            [attr.test-id]="'duplicate-select-' + element.task._id"
            (change)="validateTable()"
            (click)="$event.stopPropagation()"
            [(ngModel)]="selectedTasks[element.task._id]"
          />
        </td>
      </ng-container>

      <ng-container matColumnDef="protocol">
        <th *matHeaderCellDef mat-header-cell>Protocol</th>
        <td *matCellDef="let duplicate" mat-cell test-id="duplicate-protocol">
          <fw-ellipsis [text]="duplicate.task.protocolLabel || ''" />
        </td>
      </ng-container>

      <ng-container matColumnDef="container">
        <th *matHeaderCellDef mat-header-cell>{{ 'Container' | titlecase }}</th>
        <td *matCellDef="let duplicate" mat-cell test-id="duplicate-container">
          <span [fwTooltip]="duplicate.task.container.hierarchy">
            {{ duplicate.task.container.label }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="assignee">
        <th *matHeaderCellDef mat-header-cell>Assignee</th>
        <td *matCellDef="let duplicate" mat-cell test-id="duplicate-assignee">
          @if (duplicate.editing.assignee) {
            <div class="mat-form-field narrow">
              <app-typeahead
                class="solid-background"
                placeholder="Assignee"
                style="width: 160px"
                test-id="user-typeahead"
                [formControl]="duplicate.form.get('assignee')"
                [options]="userOptions$ | async"
                [validators]="[requiredAssigneeValidator]"
              />
            </div>
          } @else {
            <app-avatar [enableAnimation]="true" [enablePopover]="false" [users]="duplicate.task.user" />
            <span>{{ duplicate.task.user.firstname }} {{ duplicate.task.user.lastname }}</span>
            <mat-icon class="action-icon xs" fwTooltip="Assignee" (click)="duplicate.editing.assignee = true">
              edit
            </mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="dueDate">
        <th *matHeaderCellDef mat-header-cell>Date Due</th>
        <td *matCellDef="let duplicate" mat-cell test-id="duplicate-dueDate">
          @if (duplicate.editing.dueDate) {
            <mat-form-field appearance="outline" class="date-field flex-field narrow">
              <input
                autocomplete="off"
                matInput
                placeholder="Select Date"
                test-id="due-date-input"
                [formControl]="duplicate.form.get('dueDate')"
                [matDatepicker]="datepicker"
              />
              <mat-datepicker-toggle class="xs" test-id="due-date-picker-toggle" [for]="datepicker">
                <mat-icon class="xs" matDatepickerToggleIcon>event</mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #datepicker />
              @if (duplicate.form.get('dueDate').hasError('required')) {
                <mat-error>Date Due is required.</mat-error>
              }
              @if (duplicate.form.get('dueDate').hasError('dateIsPast')) {
                <mat-error>Date Due must be a future date.</mat-error>
              }
            </mat-form-field>
          } @else {
            <span>{{ defaultDueDate }}</span>
            <mat-icon class="action-icon xs" fwTooltip="Edit Due Date" (click)="duplicate.editing.dueDate = true">
              edit
            </mat-icon>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="taskId">
        <th *matHeaderCellDef mat-header-cell>Duplicate Task ID</th>
        <td *matCellDef="let duplicate" mat-cell test-id="duplicate-taskId">
          <fw-ellipsis [text]="duplicate.task.duplicateId || ''" />
        </td>
      </ng-container>

      <tr *matHeaderRowDef="duplicateColumns; sticky: true" mat-header-row></tr>
      <tr *matRowDef="let row; columns: duplicateColumns" mat-row></tr>
    </table>
  </div>
  <!-- TODO: Add additional details once FLYW-11324 is ready -->
  <p class="marked-for-creation dialog-padding">{{ selectedTaskCount }} tasks marked for creation</p>
</div>

<div align="end" class="action-buttons" mat-dialog-actions>
  <button color="primary" mat-dialog-close mat-stroked-button test-id="close-button">Cancel</button>
  <button color="primary" mat-stroked-button test-id="ignore-button" (click)="createTasks(false)">
    Ignore Duplicates
  </button>
  <button
    color="primary"
    mat-flat-button
    test-id="create-continue-button"
    [disabled]="!selectionValid || selectedTaskCount === 0"
    (click)="createTasks(true)"
  >
    Create Duplicates
  </button>
</div>
